import GraphqlBuilder from "utils/request/graphql/builder";
import _ from 'lodash'
import MutationEmployeeWebAuthentication from 'graphql/mutations/MutationEmployeeWebAuthentication'
import { constantsActive } from 'utils/constants/constants'

const Qrcode_Authentication = {
	
	scan: ( qrcode, onSuccess, onError ) => {
		const graphQlBuilder = new GraphqlBuilder();
		
		graphQlBuilder.addQuery( 'scan', MutationEmployeeWebAuthentication, {
			code: qrcode
		});
		
		graphQlBuilder.setOnSuccess( Qrcode_Authentication.handledScan.bind( this, onSuccess, onError ) );
		graphQlBuilder.setOnError( onError );
		graphQlBuilder.execute();
	},
	
	handledScan: ( onSuccess, onError, result ) => {
		let error = _.get( result, [ 'scan', 'employee_web_authentication', 'error' ], constantsActive.YES );
		
		if ( error === constantsActive.YES ) {
			onError();
			return
		}
		
		onSuccess();
	},
};

export default Qrcode_Authentication
